<template>
  <div>
    <NewHeader />
    <div class="container mt-4 mb-5">
      <FullCalendar :options="calendarOptions" />
    </div>


    <Footer />
    <BackUp />
  </div>
</template>

<script>
import { calendarEvent } from '@/Data/event.js';
import Header from '@/components/navigation/Header.vue';
import Footer from '@/components/navigation/Footer.vue';
import NewHeader from '@/components/navigation/NewHeader.vue';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/list'
import listPlugin from '@fullcalendar/interaction'
import BackUp from '@/components/BackUp.vue';
// import { INITIAL_EVENTS, createEventId } from './event-utils'
export default {
  components: {
    Header,
    Footer,
    FullCalendar,
    NewHeader,
    BackUp
  },
  data() {
    return {
      calendarOptions: {
        plugins: [
          dayGridPlugin,
           timeGridPlugin,
           listPlugin,
          interactionPlugin // needed for dateClick
        ],
         headerToolbar: {
          left: 'dayGridMonth,timeGridWeek,timeGridDay',
          center: 'title',
          right: 'prev next today'
        },
         initialView: 'timeGridWeek',
        //  dateClick: this.handleDateClick,
        events: [],
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        // select: this.handleDateSelect,
        // eventClick: this.handleEventClick,
        eventsSet: this.handleEvents
      }
    }
  },


  methods: {
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    loadEvents() {
        calendarEvent.map((element) => {
          this.calendarOptions.events.push(element)
        })
      },

    // handleDateSelect(selectInfo) {
    //   let title = prompt('Please enter a new title for your event')
    //   let calendarApi = selectInfo.view.calendar
    //   calendarApi.unselect() // clear date selection
    //   if (title) {
    //     calendarApi.addEvent({
    //       id: createEventId(),
    //       title,
    //       start: selectInfo.startStr,
    //       end: selectInfo.endStr,
    //       allDay: selectInfo.allDay
    //     })
    //   }
    // },
    // handleEventClick(clickInfo) {
    //   if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
    //     clickInfo.event.remove()
    //   }
    // },
    handleEvents(events) {
      this.currentEvents = events
    },
    //   handleDateClick(arg) {
    //   alert('date click! ' + arg.dateStr)
    // }
  },
  mounted() {
    this.loadEvents()
  }

}
</script>
